export default __webpack_public_path__ + "static/media/sauced_strawberry_right.680d9eeb.png";